import { useUserContext } from "../auth/userContextProvider/UserContextProvider";
import { useUrlProvider } from "../useUrlProvider";

export interface LinkableLegalEntity {
    id: string;
    isCustomerOwned: boolean;
}

// Group companies only open for users who manage them, the way the contract parties tiles link them.
export function useLegalEntityLink() {
    const { permissions } = useUserContext();
    const urlProvider = useUrlProvider();

    function getLegalEntityLink(legalEntity: LinkableLegalEntity) {
        if (legalEntity.isCustomerOwned) {
            return permissions.canManageGroupEntities ? urlProvider.getGroupEntityUrl(legalEntity.id) : undefined;
        }
        return urlProvider.getLegalEntityUrl(legalEntity.id);
    }

    return { getLegalEntityLink };
}
